import React, { useEffect, useState } from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import * as S from './styles';
import selectors from '@state/selectors';
import DeleteIcon from '@assets/icons/deleteIcon';
import { IDesign } from '@state/designs/types';

const RightClickMenu:React.FC<IProps> = (props) => {

  const [coordinates, setCoordinates] = useState({x: 0, y:0});
  const [selectedDesigns, setSelectedDesigns] = useState<IDesign[]>([]);

  const addUpdateResponse = useSelector(selectors.brands.getAddUpdateBrand);

  useEffect(() => {
    if (props.open) setCoordinates(props.coordinates);
  }, [props.open]);

  useEffect(() => {
    if (addUpdateResponse || props.items?.length) {
      handleCloseWarning();
    }
  }, [addUpdateResponse, props.items?.length]);

  useEffect(() => {
    if (props.selectedIndexes.length > 0) {
      setCoordinates(props.coordinates);
      let newSelectedDesigns: IDesign[] = [];
      props.selectedIndexes.map(selectedIndex => {
        const item = props.items[selectedIndex];
        if (item) {
          newSelectedDesigns = [...newSelectedDesigns, item];
        }
      });
      setSelectedDesigns(newSelectedDesigns);
    } else {
      setSelectedDesigns([]);
    }
  }, [props.selectedIndexes]);

  const sValue = props.selectedIndexes.length > 1 ? `s` : ``;

  const handleDelete = () => {
    props.handleWarningScreen(
      true, `Delete Design${sValue}`,
      `Are you sure you want to delete these designs?`,
      "CANCEL", () => {handleFinishDelete()}, "DELETE", "", []
    );
  }

  const handleCloseWarning = () => {
    props.handleWarningScreen(false, ``, ``, "", undefined, "", "", []);
  };

  const handleFinishDelete = () => {
    if (selectedDesigns.length > 0 && props.onActions) {
      props.handleWarningScreen(
        true, `Delete Design${sValue}`,
        `Are you sure you want to delete these designs?`,
        "CANCEL", undefined, "DELETING...", "", []
      );
      props.onActions(selectedDesigns, 'DELETEMULTIPLE');
    } else {
      handleCloseWarning();
    }
  }

  return (
    <S.Root>
      {
        (props.selectedIndexes.length > 0 && !props.open) &&
        <S.AuxText
          xValue={coordinates.x}
          yValue={coordinates.y}
        >
          Right click to see options
        </S.AuxText>
      }
      {
        (props.selectedIndexes.length > 0 && props.open) &&
        <S.MenuContainer
          xValue={coordinates.x}
          yValue={coordinates.y}
        >
          <S.MenuTitle>
            {`${props.selectedIndexes.length} Item${sValue}`}
          </S.MenuTitle>
          <S.MenuSubtitle>
            {`Folder: ${props.selectedFolder}`}
          </S.MenuSubtitle>
          <S.MenuDivider />
          <S.MenuActionContainer>
            <S.MenuActionRow
              onClick={handleDelete}
            >
              <S.MenuActionIcon>
                <DeleteIcon />
              </S.MenuActionIcon>
              <S.MenuAactionText>
                {`Delete Design${sValue}`}
              </S.MenuAactionText>
            </S.MenuActionRow>
          </S.MenuActionContainer>
        </S.MenuContainer>
      }
    </S.Root>
  );
}

export default RightClickMenu;